module.exports = __webpack_public_path__ + "static/media/potatis@2x.da40e7c5.png";